// src/service/axiosInstance.js
import { API_URL } from "@/constants/environment";
import axios from "axios";
import { toast } from "react-toastify";

// Set your base API URL
const HBN_API_URL = import.meta.env.VITE_API_URL || API_URL
const axiosInstance = axios.create({
  baseURL: HBN_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// 🔐 Request interceptor to add token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 🚨 Response interceptor to catch 401
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.log("401 Unauthorized - redirecting to home page");
      localStorage.removeItem("access_token");
      localStorage.removeItem("onboard_access_token");
      // Redirect to main home page on 401
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
